(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boss-visions-portfolio"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init(root) {
    root.querySelectorAll('.bv-portfolio').forEach(function(portfolio) {
      if (portfolio.dataset.bvReady === 'yes') return;
      portfolio.dataset.bvReady = 'yes';

      portfolio.querySelectorAll('[data-bv-category]').forEach(function(category) {
        var track = category.querySelector('[data-bv-track]');
        if (!track) return;

        var slides = Array.from(track.querySelectorAll('.bv-slide'));
        var current = category.querySelector('[data-bv-current]');

        function index() {
          if (slides.length < 2) return 0;

          var width = slides[1].offsetLeft - slides[0].offsetLeft;

          return Math.max(
            0,
            Math.min(
              slides.length - 1,
              Math.round(track.scrollLeft / Math.max(1, width))
            )
          );
        }

        function move(direction) {
          var target = Math.max(
            0,
            Math.min(slides.length - 1, index() + direction)
          );

          track.scrollTo({
            left: slides[target].offsetLeft - slides[0].offsetLeft,
            behavior: 'smooth'
          });
        }

        var prev = category.querySelector('[data-bv-prev]');
        var next = category.querySelector('[data-bv-next]');

        if (prev) {
          prev.addEventListener('click', function() {
            move(-1);
          });
        }

        if (next) {
          next.addEventListener('click', function() {
            move(1);
          });
        }

        track.addEventListener('scroll', function() {
          if (current) {
            current.textContent = String(index() + 1);
          }
        }, { passive: true });
      });

      var dialog = portfolio.querySelector('[data-bv-lightbox]');

      if (dialog && typeof dialog.showModal === 'function') {
        portfolio.querySelectorAll('[data-bv-enlarge]').forEach(function(link) {
          link.addEventListener('click', function(event) {
            event.preventDefault();

            var img = dialog.querySelector('[data-bv-large]');
            img.src = link.href;

            var sourceImg = link.querySelector('img');
            img.alt = sourceImg ? sourceImg.alt : 'Portfolio design';

            dialog.querySelector('[data-bv-caption]').textContent = img.alt;
            dialog.showModal();
          });
        });

        dialog.querySelector('[data-bv-close]').addEventListener('click', function() {
          dialog.close();
        });

        dialog.addEventListener('click', function(event) {
          if (event.target === dialog) dialog.close();
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bv-client-reviews"] && !Shopify.designMode) return;
  try {
    

(function () {

  function setup(root) {

    root.querySelectorAll('.bv-client-reviews').forEach(function(section) {

      if (section.dataset.bvReviewsReady === 'yes') {
        return;
      }

      section.dataset.bvReviewsReady = 'yes';

      var track = section.querySelector(
        '[data-bv-reviews-slider]'
      );

      if (!track) {
        return;
      }

      var cards = Array.from(
        track.querySelectorAll('.bv-review')
      );

      var prev = section.querySelector('[data-bv-prev]');
      var next = section.querySelector('[data-bv-next]');

      function step(direction) {

        if (cards.length < 2) {
          return;
        }

        var distance =
          cards[1].offsetLeft - cards[0].offsetLeft;

        track.scrollBy({
          left: distance * direction,
          behavior: 'smooth'
        });

      }

      if (prev) {
        prev.addEventListener('click', function() {
          step(-1);
        });
      }

      if (next) {
        next.addEventListener('click', function() {
          step(1);
        });
      }

    });

  }

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', function() {
      setup(document);
    });

  } else {

    setup(document);

  }

  document.addEventListener(
    'shopify:section:load',
    function(event) {
      setup(event.target);
    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
